import { vModelText as _vModelText, createVNode as _createVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "d-flex justify-content-between" }
const _hoisted_4 = { class: "dropdown" }
const _hoisted_5 = /*#__PURE__*/_createVNode("i", { class: "fas fa-file-download" }, null, -1)
const _hoisted_6 = {
  class: "dropdown-menu",
  "aria-labelledby": "dropdownMenuButton"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" No customers. ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Loading customers data. Please wait. ")
const _hoisted_9 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_10 = {
  key: 0,
  class: "table table-sm table-striped"
}
const _hoisted_11 = {
  key: 0,
  scope: "row"
}
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_CardBase = _resolveComponent("CardBase")

  return (_openBlock(), _createBlock(_component_CardBase, {
    allowBack: false,
    title: "All Balances"
  }, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_DataTable, {
            class: "p-datatable-sm",
            value: _ctx.getFilteredUsers,
            paginator: true,
            rows: 10,
            rowsPerPageOptions: [10, 20, 50],
            autoLayout: true,
            filterDisplay: "menu",
            paginatorTemplate: "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
            currentPageReportTemplate: "Showing {first} to {last} of {totalRecords}",
            resizableColumns: true,
            columnResizeMode: "fit"
          }, {
            header: _withCtx(() => [
              _createVNode("div", _hoisted_3, [
                _withDirectives(_createVNode("input", {
                  type: "text",
                  class: "form-control w-50",
                  placeholder: "Search...",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.mainSearch = $event))
                }, null, 512), [
                  [_vModelText, _ctx.mainSearch]
                ]),
                _createVNode("div", _hoisted_4, [
                  _createVNode("button", {
                    disabled: _ctx.isLoading,
                    class: "btn btn-primary btn-sm dropdown-toggle",
                    type: "button",
                    id: "dropdownMenuButton",
                    "data-toggle": "dropdown",
                    "aria-expanded": "false"
                  }, [
                    _hoisted_5
                  ], 8, ["disabled"]),
                  _createVNode("div", _hoisted_6, [
                    _createVNode("a", {
                      class: "dropdown-item",
                      href: "#",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.downloadXls('xls')))
                    }, "xls"),
                    _createVNode("a", {
                      class: "dropdown-item",
                      href: "#",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.downloadXls('csv')))
                    }, "csv")
                  ])
                ])
              ])
            ]),
            empty: _withCtx(() => [
              _hoisted_7
            ]),
            loading: _withCtx(() => [
              _hoisted_8
            ]),
            default: _withCtx(() => [
              _createVNode(_component_Column, {
                header: "ID",
                bodyStyle: "text-align: left"
              }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data?.customerId), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                field: "email",
                header: "Customer",
                bodyStyle: "text-align: left"
              }, {
                body: _withCtx((slotProps) => [
                  _createVNode("code", null, _toDisplayString(slotProps.data?.customer?.firstName || '---'), 1),
                  _hoisted_9,
                  _createVNode("code", null, _toDisplayString(slotProps.data?.customer?.email), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                header: "Balances",
                bodyStyle: "text-align: left; max-wight: 50%"
              }, {
                body: _withCtx((slotProps) => [
                  (slotProps.data.balances.length > 0)
                    ? (_openBlock(), _createBlock("table", _hoisted_10, [
                        _createVNode("tbody", null, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(slotProps.data.balances, (b, index) => {
                            return (_openBlock(), _createBlock("tr", { key: index }, [
                              b
                                ? (_openBlock(), _createBlock("th", _hoisted_11, _toDisplayString(b?.id), 1))
                                : _createCommentVNode("", true),
                              b
                                ? (_openBlock(), _createBlock("td", _hoisted_12, _toDisplayString(b?.currencyType === 1
                          ? '$ ' + _ctx.formatPrice(b.balance)
                          : _ctx.formatZeros(b?.balance, b?.exact)), 1))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ])
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_13, " No assets to show "))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value"])
        ])
      ])
    ]),
    _: 1
  }))
}